module.exports = __webpack_public_path__ + "img/disc_full.4e9a2622.svg";